import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #TEXT-LINK
\*------------------------------------ */
/**
 * 1) General text link used across the product
 */
:is(.cat-c-text-link, .cat-c-text-link ::slotted(a)) {
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  display: inline-flex;
  cursor: pointer;
  text-decoration: underline;
  color: var(--cat-theme-color-content-link-default);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
:is(.cat-c-text-link, .cat-c-text-link ::slotted(a)):hover {
  color: var(--cat-theme-color-content-link-hover);
}
:is(.cat-c-text-link, .cat-c-text-link ::slotted(a)):active {
  color: var(--cat-theme-color-content-link-active);
}
:is(.cat-c-text-link, .cat-c-text-link ::slotted(a)):visited {
  color: var(--cat-theme-color-content-link-visited);
}
:is(.cat-c-text-link, .cat-c-text-link ::slotted(a)):focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}

/**
 * Inverted text link
 * 1) Used on dark backgrounds
 */
:is(.cat-c-text-link--inverted, .cat-c-text-link--inverted ::slotted(a)) {
  color: var(--cat-theme-color-content-link-inverted-inverse);
}
:is(.cat-c-text-link--inverted, .cat-c-text-link--inverted ::slotted(a)):hover {
  color: var(--cat-theme-color-content-link-inverted-hover);
}
:is(.cat-c-text-link--inverted, .cat-c-text-link--inverted ::slotted(a)):visited {
  color: var(--cat-theme-color-content-link-inverted-visited);
}
:is(.cat-c-text-link--inverted, .cat-c-text-link--inverted ::slotted(a)):active {
  color: var(--cat-theme-color-content-link-inverted-active);
}
:is(.cat-c-text-link--inverted, .cat-c-text-link--inverted ::slotted(a)):focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}

/**
 * Extra small text link
 * 1) Shrink the typography size
 */
:is(.cat-c-text-link--xs, .cat-c-text-link--xs ::slotted(a)) {
  font-family: var(--cat-theme-typography-footnote-font-family);
  font-weight: var(--cat-theme-typography-footnote-font-weight);
  font-size: var(--cat-theme-typography-footnote-font-size);
  line-height: var(--cat-theme-typography-footnote-line-height);
}

/**
 * Small text link
 * 1) Shrink the typography size
 */
:is(.cat-c-text-link--sm, .cat-c-text-link--sm ::slotted(a)) {
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
}

/**
 * Text link after
 * 1) Container used to place items after the text link
 */
.cat-c-text-link__after {
  margin-inline-start: var(--cat-space-x-small);
}

.cat-c-text-link:not(.cat-c-text-link--has-link-after) .cat-c-text-link__after {
  display: none;
}
`;
       